"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeofenceAlert = void 0;
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _pittaModules = require("@thingsw/pitta-modules");
var _Geofence = require("../icons/Geofence");
var _GeofenceEnter = require("../icons/GeofenceEnter");
var _GeofenceExit = require("../icons/GeofenceExit");
var _GeofencePass = require("../icons/GeofencePass");
var _Typography = require("./Typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var colors = {
  Enter: _pittaModules.LightColors.secondary["15"],
  Exit: _pittaModules.LightColors.secondary["11"],
  Pass: _pittaModules.LightColors.secondary["17"]
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: theme.spacing(2),
      height: 137
    },
    textRowDiv: {
      display: "flex",
      alignItems: "center"
    },
    iconDiv: {
      width: 37,
      paddingLeft: 3,
      display: "flex",
      alignItems: "center"
    }
  };
});
var GeofenceAlert = function GeofenceAlert(_ref) {
  var date = _ref.date,
    fenceName = _ref.fenceName,
    sendStatus = _ref.sendStatus,
    latLng = _ref.latLng;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "BodyBold"
  }, date)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textRowDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconDiv
  }, /*#__PURE__*/_react.default.createElement(_Geofence.Geofence, {
    style: {
      width: 18,
      height: 18,
      color: _pittaModules.LightColors.primary["3"]
    }
  })), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body"
  }, fenceName)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textRowDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconDiv
  }, sendStatus === "Enter" && /*#__PURE__*/_react.default.createElement(_GeofenceEnter.GeofenceEnter, {
    style: {
      width: 18,
      height: 18,
      color: colors[sendStatus]
    }
  }), sendStatus === "Exit" && /*#__PURE__*/_react.default.createElement(_GeofenceExit.GeofenceExit, {
    style: {
      width: 18,
      height: 18,
      color: colors[sendStatus]
    }
  }), sendStatus === "Pass" && /*#__PURE__*/_react.default.createElement(_GeofencePass.GeofencePass, {
    style: {
      width: 18,
      height: 18,
      color: colors[sendStatus]
    }
  })), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Body",
    htmlColor: colors[sendStatus]
  }, sendStatus)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textRowDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconDiv
  }), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, latLng)));
};
exports.GeofenceAlert = GeofenceAlert;